import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import useMutationObserver from '@rooks/use-mutation-observer';
import { useWindowSize } from "./useWindowSize";
import { useOnLoadImages } from "./useOnLoadImages";
export var useSyncedScroll = function (conf) {
  if (conf === void 0) {
    conf = {
      snapTo: 'top',
      verticalPadding: 0
    };
  }
  var container1Ref = useRef(null);
  var container2Ref = useRef(null);
  var snapTo = conf.snapTo || 'top';
  var topPadding = (typeof conf.topPadding === "number" ? conf.topPadding : undefined) || conf.verticalPadding || 0;
  var bottomPadding = (typeof conf.bottomPadding === "number" ? conf.bottomPadding : undefined) || conf.verticalPadding || 0;
  console.log(topPadding, bottomPadding);
  var vars = useRef({
    last: 0,
    relativeScrollOffset: 0,
    isBottomFixed: false,
    isTopFixed: false,
    lastContainer1Size: undefined,
    lastContainer2Size: undefined,
    lastContainer1: undefined,
    lastContainer2: undefined
  });
  var _a = useState(null),
    spacer = _a[0],
    setSpacer = _a[1];
  var windowSize = useWindowSize(1000, 1000);
  var _b = useState(function () {
      return function () {};
    }),
    updateScroll = _b[0],
    setUpdateScroll = _b[1];
  var init = function () {
    if (container1Ref.current === null) {
      return;
    }
    if (container2Ref.current === null) {
      return;
    }
    var spacer1 = document.createElement('div');
    var spacer2 = document.createElement('div');
    spacer = [spacer1, spacer2];
    setSpacer([spacer1, spacer2]);
    container1Ref.current.after(spacer1);
    container2Ref.current.after(spacer2);
    container1Ref.current.style.willChange = 'position';
    container2Ref.current.style.willChange = 'position';
    if (typeof window !== "undefined") {
      window['reactUseSyncedScrollUpdateLayout'] = function () {
        return updateLayout();
      };
    }
  };
  var updateLayout = function () {
    if (!spacer) {
      return;
    }
    if (container1Ref.current === null) {
      return;
    }
    if (container2Ref.current === null) {
      return;
    }
    var spacer1Width = spacer[0].clientWidth;
    var spacer2Width = spacer[1].clientWidth;
    container1Ref.current.style.width = spacer1Width + 'px';
    spacer[0].style.height = container1Ref.current.clientHeight + 'px';
    container2Ref.current.style.width = spacer2Width + 'px';
    spacer[1].style.height = container2Ref.current.clientHeight + 'px';
    if (container1Ref.current !== vars.current.lastContainer1 || container2Ref.current !== vars.current.lastContainer2) {
      container1Ref.current.style.position = 'absolute';
      container2Ref.current.style.position = 'absolute';
      container1Ref.current.style.top = '0';
      container2Ref.current.style.top = '0';
    }
    vars.current.lastContainer1 = container1Ref.current;
    vars.current.lastContainer2 = container2Ref.current;
    updateScroll();
  };
  var getOffsetTop = function (element) {
    return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
  };
  var measure = function () {
    if (!spacer || container1Ref.current === null || container2Ref.current === null) {
      return {
        container1Size: {
          height: 0,
          width: 0,
          offsetTop: 0
        },
        container2Size: {
          height: 0,
          width: 0,
          offsetTop: 0
        }
      };
    }
    var rect1 = spacer[0].getBoundingClientRect();
    var rect2 = spacer[1].getBoundingClientRect();
    var container1Size = {
      height: rect1.height,
      width: rect1.width,
      offsetTop: getOffsetTop(spacer[0])
    };
    var container2Size = {
      height: rect2.height,
      width: rect2.width,
      offsetTop: getOffsetTop(spacer[1])
    };
    return {
      container1Size: container1Size,
      container2Size: container2Size
    };
  };
  var onScrollChange = function () {
    var onScroll = function () {
      if (!spacer) {
        return;
      }
      if (container1Ref.current === null) {
        return;
      }
      if (container2Ref.current === null) {
        return;
      }
      var latest = window.scrollY + topPadding;
      var viewportHeight = windowSize.height - (topPadding + bottomPadding);
      var _a = measure(),
        container1Size = _a.container1Size,
        container2Size = _a.container2Size;
      var firstContainerScrolling = container1Size.height >= container2Size.height;
      if (vars.current.isBottomFixed && vars.current.lastContainer1Size && vars.current.lastContainer2Size) {
        if (firstContainerScrolling) {
          if (container2Size.height !== vars.current.lastContainer2Size.height) {
            vars.current.isBottomFixed = false;
          }
        } else {
          if (container1Size.height !== vars.current.lastContainer1Size.height) {
            vars.current.isBottomFixed = false;
          }
        }
      }
      vars.current.lastContainer1Size = container1Size;
      vars.current.lastContainer2Size = container2Size;
      var scrollingContainer = firstContainerScrolling ? container1Ref.current : container2Ref.current;
      var scrollingContainerSize = firstContainerScrolling ? container1Size : container2Size;
      var snappingContainer = firstContainerScrolling ? container2Ref.current : container1Ref.current;
      var snappingContainerSize = firstContainerScrolling ? container2Size : container1Size;
      var snappingContainerBiggerThanViewport = snappingContainerSize.height > viewportHeight;
      var start = Math.min(container1Size.offsetTop, container2Size.offsetTop);
      var end = Math.max(container1Size.offsetTop + container1Size.height, container2Size.offsetTop + container2Size.height);
      if (!snappingContainerBiggerThanViewport) {
        var snappingTopOffset = void 0;
        switch (snapTo) {
          case 'top':
            snappingTopOffset = 0;
            break;
          case 'center':
            snappingTopOffset = viewportHeight / 2 - snappingContainerSize.height / 2;
            break;
          case 'bottom':
            snappingTopOffset = viewportHeight - snappingContainerSize.height;
            break;
        }
        var afterStart = latest + snappingTopOffset >= start;
        var beforeEnd = latest + snappingTopOffset + snappingContainerSize.height <= end;
        if (afterStart && beforeEnd) {
          snappingContainer.style.position = 'fixed';
          snappingContainer.style.top = snappingTopOffset + topPadding + 'px';
        } else {
          snappingContainer.style.position = 'absolute';
        }
        if (!afterStart && beforeEnd) {
          snappingContainer.style.top = '0';
        }
        if (!beforeEnd) {
          snappingContainer.style.top = scrollingContainerSize.height - snappingContainerSize.height + 'px';
        }
        scrollingContainer.style.position = 'absolute';
        scrollingContainer.style.top = '0';
      } else {
        var afterStart = latest >= start;
        var beforeEnd = latest + viewportHeight <= end;
        if (afterStart && beforeEnd) {
          if (latest < vars.current.last) {
            if (vars.current.isBottomFixed) {
              vars.current.relativeScrollOffset = latest - snappingContainerSize.offsetTop - snappingContainerSize.height + viewportHeight;
              snappingContainer.style.position = 'absolute';
              snappingContainer.style.top = vars.current.relativeScrollOffset + 'px';
              vars.current.isBottomFixed = false;
            }
            if (latest < start + vars.current.relativeScrollOffset) {
              snappingContainer.style.position = 'fixed';
              snappingContainer.style.top = "".concat(topPadding, "px");
              vars.current.relativeScrollOffset = 0;
              vars.current.isTopFixed = true;
            }
          } else {
            if (vars.current.isTopFixed) {
              vars.current.relativeScrollOffset = latest - snappingContainerSize.offsetTop;
              snappingContainer.style.position = 'absolute';
              snappingContainer.style.top = vars.current.relativeScrollOffset + 'px';
              vars.current.isTopFixed = false;
            }
            if (latest + viewportHeight > snappingContainerSize.offsetTop + snappingContainerSize.height + vars.current.relativeScrollOffset) {
              snappingContainer.style.position = 'fixed';
              snappingContainer.style.top = viewportHeight - snappingContainerSize.height + topPadding + 'px';
              vars.current.isBottomFixed = true;
            }
          }
        }
        if (!afterStart) {
          snappingContainer.style.position = 'absolute';
          snappingContainer.style.top = '0';
          vars.current.isTopFixed = false;
          vars.current.isBottomFixed = false;
          vars.current.relativeScrollOffset = 0;
        }
        if (!beforeEnd) {
          snappingContainer.style.position = 'absolute';
          snappingContainer.style.top = scrollingContainerSize.height - snappingContainerSize.height + 'px';
          vars.current.isTopFixed = false;
          vars.current.isBottomFixed = true;
          vars.current.relativeScrollOffset = 0;
        }
      }
      vars.current.last = latest;
    };
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    var removeScroll = function () {
      return window.removeEventListener('scroll', onScroll);
    };
    setUpdateScroll(function () {
      return function () {
        return onScroll();
      };
    });
    return removeScroll;
  };
  useEffect(function () {
    init();
    updateLayout();
    return function () {
      if (spacer) {
        spacer[0].remove();
        spacer[1].remove();
      }
    };
  }, []);
  useEffect(function () {
    return onScrollChange();
  }, []);
  useLayoutEffect(function () {
    if (spacer) {
      updateLayout();
    }
  });
  useOnLoadImages(container1Ref, function () {
    return updateLayout();
  });
  useOnLoadImages(container2Ref, function () {
    return updateLayout();
  });
  useMutationObserver(container1Ref, function (mutations) {
    if (mutations.filter(function (mutation) {
      return mutation.type !== 'attributes' || mutation.target !== container1Ref.current;
    }).length > 0) {
      updateLayout();
    }
  });
  useMutationObserver(container2Ref, function (mutations) {
    if (mutations.filter(function (mutation) {
      return mutation.type !== 'attributes' || mutation.target !== container2Ref.current;
    }).length > 0) {
      updateLayout();
    }
  });
  return [container1Ref, container2Ref];
};